import currency from 'currency.js';
// @ts-ignore
import { itemTotalPrice, shouldApplyItemFeeByServiceType } from '@vmos2/price';
import { Item } from './types';
import { useMemo } from 'react';

type Options = { items: Item[], price: number, isTakeAway: boolean };
export const usePriceExcludingFees = ({ items, price, isTakeAway }: Options) => {
  return useMemo(() => {
    const applicableFeesToExcludeFromPrice = items?.filter(
      item => item.isFee && !item.feeInfo?.includeInBasePrice && shouldApplyItemFeeByServiceType(item, isTakeAway)
    );
    const priceToExclude = applicableFeesToExcludeFromPrice?.reduce((acc, item) => {
      return acc.add(itemTotalPrice(item, isTakeAway));
    }, currency(0));
    return currency(price).subtract(priceToExclude).value;
  }, [items, price, isTakeAway]);
};
